export default "__VITE_ASSET__DhHrLMFl__"